const InquirySkeletonBody = ({currentInquiries,loading}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {
      Array.from({ length: 6 }).map((_, index) => (
          <div
            key={`skeleton-${index}`}
            className="bg-white rounded-lg shadow-md p-6 border border-gray-200 animate-pulse"
          >
            <div className="h-6 bg-gray-300 rounded mb-4"></div>
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="flex items-center mb-2">
                <div className="w-12 h-4 bg-gray-300 rounded mr-2"></div>
                <div className="h-4 bg-gray-300 rounded flex-1"></div>
              </div>
            ))}
            <div className="h-16 bg-gray-300 rounded mb-4"></div>
          </div>
        ))
     }
    </div>
  );
};

export default InquirySkeletonBody;
